module.exports = __webpack_public_path__ + "img/new_2.3aa118ea.png";